export enum EProjectStatus {
  Pipeline = 'pipeline',
  Registration = 'registration',
  Implementation = 'implementation',
  Completion = 'completion',
  Archived = 'archived',
  Draft = 'draft'
}

export enum EFilterProjectStatus {
  All= 'all',
  Pipeline = 'pipeline',
  Registration = 'registration',
  Implementation = 'implementation',
  Completion = 'completion',
  Archived = 'archived',
}